// extracted by mini-css-extract-plugin
export default {"pageNumber":"_e132fa4f","pageNumberMobilePortrait":"_3806be98"};